import styled from 'styled-components';
import type { FunctionalComponent } from 'apps/core/types/global.types';

export interface Props {
  message: string;
  type?: 'positive' | 'negative' | 'warning';
}

const StatusMessageText = styled.span<{
  type?: Props['type'];
}>`
  color: ${(props) => {
    switch (props.type) {
      case 'positive':
        return 'green';
      case 'negative':
        return 'red';
      default:
        return 'inherit';
    }
  }};
`;

const StatusMessage: FunctionalComponent<Props> = ({ message, type }) => (
  <StatusMessageText type={type}>{message}</StatusMessageText>
);

export default StatusMessage;
